export default __webpack_public_path__ + "static/media/else.a08c2615.png";